<template>
  <div class="service-detail">
    <div class="title">{{ item.serviceName }}</div>
    <div class="sub-title">{{ item.hasMore ? '平台' : '功能'}}简介</div>
    <div class="desc">{{ item.serviceIntro }}</div>
    <template v-if="item.hasMore">
      <div class="more-info">
        <p>联系邮箱：{{ item.email }}</p>
        <p>联系电话：{{ item.phone }}</p>
        <p>联系地址：{{ item.addr }}</p>
      </div>
      <div class="more-image">
        <el-image :src="item.qrcode"
                  fit="contain"
                  :preview-src-list="[item.qrcode]">
        </el-image>
      </div>
    </template>
    <div class="image-list"
         v-else>
      <el-image v-for="(item,index) in list"
                :key="index"
                :src="item"
                fit="contain"
                :preview-src-list="list">
      </el-image>
    </div>
  </div>
</template>
<script>
export default {
  name: 'service-detail',
  props: {
    item: { type: Object, default () { return {} } }
  },
  computed: {
    list ({ item }) {
      return item.coverImage ? item.coverImage.split(',') : []
    }
  }
}
</script>
<style lang="stylus" scoped>
.title {
  font-size: 18px;
  color: #000;
  font-weight: bold;
}

.sub-title {
  font-size: 18px;
  color: #000;
  margin: 24px 0 16px;
}

.desc {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 24px;
}

.more-info {
  font-size: 18px;
  color: #000;
  line-height: 36px;
  // font-weight: bold
}
.more-image {
  /deep/ .el-image {
    display: block;
    width: 300px;
  }
}
.image-list {
  /deep/ .el-image {
    display: block;
    width: 100%;
    margin: 0 auto;
  }
}
</style>
